import React, { useEffect } from 'react'
import "../styles/portfolio.css"
import { useImages } from '../contexts/imageContext'
import { FeaturedProject } from './featuredproject'
import { useFeaturedContext } from '../contexts/featuredContext'
import { OtherProject } from './otherProject'
import { useProjects } from '../contexts/otherProjectContext'


export default function Portfolio() {
    const [images, ] = useImages()
    const [featured1, featured2, featured3]  = useFeaturedContext()
    const projects = useProjects()


  return (
    <div className="portfolio my-5" id="portfolio">
        <small className="sub-head fw-bold text-uppercase mt-0 mt-md-5 ">Some things i've built</small>
        <h3 className="display-5 mt-4 fw-bold text-uppercase">Portfolio</h3>
        <div className="projects my-5">
            
            <FeaturedProject  
                order={"order-right order-2"}
                imgOrder={"order-1"}
                image={images.featuredImg2}
                title={featured2.title}
                description = {featured2.description}
                git={featured2.git}
                live={featured2.link}
                stack={featured2.stack}
                />

            <FeaturedProject  
                order={"order-left order-1"}
                imgOrder={"order-2"}
                image={images.featuredImg1}
                title={featured1.title}
                description = {featured1.description}
                git={featured1.git}
                live={featured1.link}
                stack={featured1.stack}
                />

            <FeaturedProject  
                order={"order-right order-3"}
                imgOrder={"order-1"}
                image={images.featuredImg3}
                title={featured3.title}
                description = {featured3.description}
                git={featured3.git}
                live={featured3.link}
                stack={featured3.stack}
                />
        </div>


        <div className="worthy-projects py-5">
            <h3 className='text-center my-5 text-capitalize fw-bold'>Other noteworthy projects</h3>
            <div className="container-fluid">
                <div className="row gy-4">

                    {projects && projects.map((snapshot, id)=>{
                       return <OtherProject key={id}
                        title={snapshot.data().title}
                        description={snapshot.data().description}
                        stack={snapshot.data().stack.split("@")}
                        live={snapshot.data().link}
                        git = {snapshot.data().git}
                    />
                    })}
                    
                    
                </div>
            </div>
        </div>
    </div>
  )
}
